import { AnimatePresence, MotionConfig } from 'framer-motion';
import { IntlProvider } from 'react-intl';
import * as React from 'react';

import { SurveyConfig } from '../types';

import App from './App';

export type RootProps = {
  config: SurveyConfig;
};

const Root = ({ config }: RootProps) => (
  <IntlProvider locale={config.i18n.locale} messages={config.i18n.messages}>
    <MotionConfig transition={{ type: 'tween' }}>
      <AnimatePresence>
        <App config={config} />
      </AnimatePresence>
    </MotionConfig>
  </IntlProvider>
);

export default Root;
